import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { TYPE_ENTRY_ONLY } from "../../../../constants/install-device";
import { useLocale } from '../../../../contexts/localeContext';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';

interface SummaryProps {
    onBack: (e) => void;
}

const Summary: FC<SummaryProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>()
    
    return <div className="pt-3 pr-3 h-full relative">
        <h2 className="text-lg font-bold">{translate.byKey(TranslationKeys.selectedDevice)}</h2>
        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.name)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.fixedAddress)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.ipAddress)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{values.name}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.fixedAddress}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.ipAddress}</span>
            </div>
        </div>

        <>
            <h2 className="pt-4 text-lg font-bold">{translate.byKey(TranslationKeys.selectedPeripherals)}</h2>
            <div className="flex flex-col break-words">
                {values.selectedPeripherals.length > 0 ?
                <span className="pt-1 text-sm text-black">{values.selectedPeripherals.toString()}</span> :
                    <span className="pt-1 text-sm text-black">{translate.byKey(TranslationKeys.autoInstallPeripherals)}</span>}
            </div>
        </>

        <>
            <h2 className="pt-4 text-lg font-bold">{translate.byKey(TranslationKeys.selectedIpDevices)}</h2>
            <div className="flex flex-col break-words">
                {values.selectIPDevices.length > 0 ?
                    <span className="pt-1 text-sm text-black">{values.selectIPDevices.toString()}</span> :
                    <span className="pt-1 text-sm text-black">{translate.byKey(TranslationKeys.none)}</span>}
            </div>
        </>

        {values.autoCreateDoors ?
            <>
                <h2 className="pt-4 text-lg font-bold">{translate.byKey(TranslationKeys.doorCreation)}</h2>
                <div className="flex flex-row">
                    <div className="flex flex-col">
                        <span className="pt-1 text-sm text-black">{translate.byKey(TranslationKeys.autoCreateDoors)}</span>
                        <span className="pt-1 text-sm text-black">
                            {values.autoCreateDoorsType === TYPE_ENTRY_ONLY ?
                                translate.byKey(TranslationKeys.entryReaderOnly) :
                                translate.byKey(TranslationKeys.exitAndEntryReaders)}
                        </span>
                    </div>
                </div>
            </> :
            null}

        <div className="flex justify-end w-full absolute bottom-0 pr-3 pb-3 ">
            <button
                className={`py-1 px-5 mt-3 mr-2 text-portal-blue-primary-shade2`}
                type="button"
                onClick={(e) => onBack(e)}>{translate.byKey(TranslationKeys.back)}</button>
            <button
                className={`py-1 px-5 mt-3 bg-lime rounded-full text-white`}
                type="submit">
                {translate.byKey(TranslationKeys.execute)}</button>
        </div>
    </div>
}

export default Summary;
